import React, { useContext } from "react";
import Header from "../header";
import Loader from "../Loader";
import CrudForm from "./crudForm";
import CrudTable from "./crudTable";
import { Routes, Route } from "react-router-dom";
import Login from "../login";
import CrudContext from "../../context/crudContext";
import ProtectedRoute from "../ProtectedRoutes";
import Error404 from "../Error404";

export default function CrudApi() {
  const { db: data, loader, auth } = useContext(CrudContext);

  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={<ProtectedRoute />}>
          <Route
            path="/administrador"
            element={
              <>
                {loader && <Loader />}
                {data && <CrudTable />}
              </>
            }
          />
          <Route path="/agregar" element={<CrudForm />} />
          <Route path="/editar/:pro_id" element={<CrudForm />} />
          <Route path="/*" element={<Error404 />} />
        </Route>
      </Routes>
    </>
  );
}
